export const SCROLL_HEIGHT_COMMON_DEVICES = '600px';
export const SCROLL_HEIGHT_SMALL_DEVICES = '300px';

export interface DropdownMonth {
  label: string;
  month: number;
}

export interface CalendarFieldDate {
  dateString: string;
  dateObject: Date;
}

export interface CalendarFieldMonthAndYear {
  month: number;
  year: number;
}

export interface CalendarConfig {
  minDate: Date;
  maxDate: Date;
  disabledDates: Date[];
}
